import { Record, List } from 'immutable';

const defaultValues = {
  id: null,
  categoryName: '',
  description: '',
  ordinal: 0,
};

export default class MenuItemCategory extends Record(defaultValues, MenuItemCategory) {
  constructor(values) {
    super({
      ...values,
    });
  }

  static getMenuItemCategoryById(menuItemCategories, id) {
    return menuItemCategories.find((category) => {
      return category.get('id') === id ? category : undefined;
    });
  }
}

export const MenuItemCategories = (data) => {
  let menusItemCategories = new List();
  if (data) {
    data.forEach((value) => {
      const { category } = value;
      menusItemCategories = menusItemCategories.push(new MenuItemCategory(category || value));
    });
  }
  return menusItemCategories;
};
